import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzIconModule } from 'ng-zorro-antd/icon';

import { ScannerCompaniesComponent } from './scanner-companies.component';

@NgModule({
  declarations: [ScannerCompaniesComponent],
  exports: [ScannerCompaniesComponent],
  imports: [CommonModule, NzIconModule],
})
export class ScannerCompaniesModule { }
